import http from './util/http-util';
import {setupJsonStreamJWTHeaders} from './util/api-util';

class CreditAssessmentServiceApi {
  static statusSubscribe = (url) => {
    return http.getReturnPlainResponse(
      null,
      url,
      setupJsonStreamJWTHeaders(null),
    );
  };
}

export default CreditAssessmentServiceApi;
